import { Expose, Transform } from 'class-transformer';
import { Model } from './model';

export class SessionsReport extends Model {
  @Expose() assignmentValue: string;
  @Expose() comment: string;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  createAt: Date | null;
  @Expose() duration: string;
  @Expose() exportedUrl: string;
  @Expose() fromSurah: string;
  @Expose() fromVerse: string;
  @Expose() hesitationErrorCount: string;
  @Expose() id: string;
  @Expose() isFirst: boolean;
  @Expose() rate: number;
  @Expose() studentId: string;
  @Expose() studentLevel: string;
  @Expose() studentName: string;
  @Expose() tajweedErrorCount: string;
  @Expose() teacherId: string;
  @Expose() teacherName: string;
  @Expose() toSurah: string;
  @Expose() toVerse: string;
  @Expose() type: string;
  @Expose() wordErrorCount: string;
  @Expose() studentCountry: string;
  @Expose() attachments: string[];
}
